import { createContext, useContext, useMemo, useState } from "react";
import { SAMPLE_ROWS } from "@/lib/sample-data";
import { computeForecast } from "@/lib/forecast";

const AppContext = createContext(null);

export const DEFAULT_SETTINGS = {
  defaultCriticality: "Medium",
  safetyHigh: 0.5,
  safetyMedium: 0.3,
  safetyLow: 0.15,
  slowMovingDays: 180,
  forecastHorizon: 30,
  currency: "$",
};

export function AppProvider({ children }) {
  // rows = null means "no upload, using sample mock data"
  const [rows, setRows] = useState(null);
  const [fileName, setFileName] = useState(null);
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);

  const activeRows = rows ?? SAMPLE_ROWS;
  const isSample = rows === null;

  const forecast = useMemo(
    () => computeForecast(activeRows, settings),
    [activeRows, settings]
  );

  const value = {
    rows,
    setRows,
    fileName,
    setFileName,
    settings,
    setSettings,
    activeRows,
    isSample,
    forecast,
    resetToSample: () => {
      setRows(null);
      setFileName(null);
    },
  };

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
}

export function useApp() {
  const ctx = useContext(AppContext);
  if (!ctx) throw new Error("useApp must be used within AppProvider");
  return ctx;
}
